module.exports = __webpack_public_path__ + "img/sixpackcarrier51.bbe7130a.jpg";